import React, { useEffect, useState, useRef } from 'react';

function ProForm({id, ai}) {
  
  const idInputRef = useRef(null); // Criando a referência
  const [optionstipo, setOptionstipo] = useState([]); 
  const [optionsuni, setOptionsuni] = useState([]); 

  useEffect(() => {
    if (idInputRef.current) {
      console.log("Referência inicializada:", idInputRef.current);
    }
  }, []);

  const handleFocus = () => {
    if (idInputRef.current) {
      idInputRef.current.focus();
    } else {
      console.log("Referência não está disponível!");
    }
  };

  


  const [formData, setFormData] = useState({
    codigo: "",
    ps: "",
    nome: "",
    tipo: "",
    ncm: "",
    ean: "",
    peso: "",
    uni: "",
    iat: "",
    ippt: "",
    tpoid: "",
    ativo: "",
    estoqueatual: "",
    estoqueminimo: "",
    estoquemaximo: "",
    valorvenda: "",
    diasvalidade: "",
    podeveder: "",
    valorcompra: "",
    caixacom: "",
    podecompra: ""
  });

  formData.codigo = id;
 
  const handleChange = (e) => {
    const { name, value, checked, type } = e.target; // Obtém as propriedades relevantes
      setFormData({ ...formData, [name]: type === "checkbox" ? checked : value});
      setFormData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    };


  const handleSubmit = async (e) => {
        e.preventDefault();
        const params = new URLSearchParams();
        for (const key in formData) {
          //if (key === "DataAte")  {formData[key] = DataParaDb(formData[key]); };
          if (key === "Situacao")  {
            if (formData[key] === "") {
              formData[key] = "Ativo"; }};
            //alert(key+ formData[key]);
            params.append(key, formData[key]);
        }
        console.log('params----->', params, formData);
    
        if (!id) {
          id = formData.id;
        }
        //alert( 'id '+id+'\n'+ 'ai '+ai+'\n'+    'params-----> '+ JSON.stringify(formData));
    
    //navigate("/PagGrid");
    const response = await fetch(`http://localhost:3001/cr_pag_Id/${id}/${ai}`, {
      method: "PUT",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData),
      //body: JSON.stringify({id: 1, bc: 2}),
      
    });
    if (response.status === 200) {
      //navigate(0);
      window.location.href = "./PagGrid";
    } else {
      console.error('Erro ao ATUALIZAR cliente:', response.status);
      alert('Erro ao ATUALIZAR-POST Cr_Pag.'+response.status);
    }
        

    console.log('data----->');
    const data = await response.json();
    alert(' >>>>>>>>>>>>>>>>>>>>>>'+data);
    
  };

  
  useEffect(() => {
    fetch("http://localhost:3001/cr_obj?obj=Tipo%20Produto")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao buscar os dados!");
        }
        return response.json();
      })
      .then((data) => {
        setOptionstipo(data.cr_obj); 
      })
      .catch((error) => console.error("Erro ao buscar os dados:", error));
  }, []);

  useEffect(() => {
    fetch("http://localhost:3001/cr_obj?obj=Produto%20Unidade")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao buscar os dados!");
        }
        return response.json();
      })
      .then((data) => {
        setOptionsuni(data.cr_obj); 
      })
      .catch((error) => console.error("Erro ao buscar os dados:", error));
  }, []);


  
  
  useEffect(() => {
    
    fetch(`http://localhost:3001/cr_pro_Codigo?codigo=${id}`)
      .then(response => {
        if (!response.ok) {
          throw new Error("Erro ao buscar os dados!");
        }
        return response.json();
      })
      .then(data => {
        //alert(formData.codigo);
        
        setFormData(prevState => ({ ...prevState, 
          codigo:data.cr_pro.Codigo, 
          ps:data.cr_pro.PS,
          nome:data.cr_pro.Nome,
          tipo:data.cr_pro.Tipo,
          ncm:data.cr_pro.NCM,
          ean:data.cr_pro.Ean,
          peso:data.cr_pro.Peso,
          uni:data.cr_pro.Uni,
          iat:data.cr_pro.iAT,
          ippt:data.cr_pro.iPPT,
          tpoid:data.cr_pro.TpoId,
          ativo:data.cr_pro.Ativo,
          estoqueatual:data.cr_pro.EstoqueAtual,
          estoqueminimo:data.cr_pro.EstoqueMinimo,
          estoquemaximo:data.cr_pro.EstoqueMaximo,
          valorvenda:data.cr_pro.ValorVenda,
          diasvalidade:data.cr_pro.DiasValidade,
          podeveder:data.cr_pro.PodeVeder,
          valorcompra:data.cr_pro.ValorCompra,
          caixacom:data.cr_pro.CaixaCom,
          podecompra:data.cr_pro.PodeCompra
        }));   
      

      })
      .catch(error => console.error("Erro ao buscar os dados:", error));
  }, [id] );


  handleFocus();
 
   return (

<div class = "areabox"> 
<form onSubmit={handleSubmit}>
    <div class="form-group">

<table class="tabform" border={0}>
<thead>
<tr>
<th  class="tabformth" colSpan={2}>
  <label for="codigo" class="form-control">Código:</label><br/>  
<input type="text" class="w15" id="codigo" name="codigo"  value={formData.codigo} onChange={handleChange} ref={idInputRef}/></th>

<th colSpan={3}><label for="nome" class="form-control">Nome:</label><br/>      <input type="text" class="w45" id="nome" name="nome" value={formData.nome} onChange={handleChange}/></th>
</tr>
<tr>
<th colSpan={3}>
<label for="tipo" class="form-control">Tipo:</label><br/>  

<select class="w45" id="tipo" name="tipo" value={formData.tipo} onChange={handleChange}>
  <option value=""></option>
  {Array.isArray(optionstipo) && optionstipo.length > 0 ? (
    optionstipo.map((option, index) => (
      <option key={index} value={option.Nome}>
        {option.Nome}
      </option>
    ))
  ) : (
    <option value="">Nenhum tipo disponível</option>
  )}
</select>
<br/><br/>  


<label for="ncm" class="form-control">NCM:</label><br/>  <input type="text" id="ncm" name="ncm" value={formData.ncm} onChange={handleChange}/><br/>
<br/>
</th>
<th>
<label class="form-control">Item de:</label><br/>
<input type="radio" id="itemdeproduto" name="ps" value="P" checked={formData.ps==="P"} onChange={handleChange}/>  <label for="itemdeproduto" class="form-control">Produto</label><br/>
<input type="radio" id="itemdeservico" name="ps" value="S" checked={formData.ps==="S"} onChange={handleChange}/>  <label for="itemdeservico" class="form-control">Serviço</label><br/>
</th>
<th>
<input type="checkbox" id="ativo"      name="ativo"      checked={formData.ativo} onChange={handleChange}/><label for="ativo" class="form-control">Ativo</label><br/>
<input type="checkbox" id="podeveder"  name="podeveder"  checked={formData.podeveder} onChange={handleChange}/><label for="podeveder" class="form-control">Pode Vender</label><br/>
<input type="checkbox" id="podecompra" name="podecompra" checked={formData.podecompra} onChange={handleChange}/><label for="podecompra" class="form-control">Pode Comprar</label><br/>
</th>
</tr>
<tr>
<th><label for="ean" class="form-control">EAN:</label> <input type="text" id="ean" name="ean" value={formData.ean} onChange={handleChange}/><br/></th>
<th colSpan={2}>
<label for="uni" class="form-control">Unidade:</label><br/>

<select class="w15" id="uni" name="uni" value={formData.uni} onChange={handleChange}>
  <option value=""></option>
  {Array.isArray(optionsuni) && optionsuni.length > 0 ? (
    optionsuni.map((option, index) => (
      <option key={index} value={option.Nome}>
        {option.Nome}
      </option>
    ))
  ) : (
    <option value="">Nenhuma Unidade disponível</option>
  )}
</select>
<br/><br/>  


</th>
<th>
<label class="form-control">Terceira casa decimal:</label><br/>
<input type="radio" id="arredondamentos" name="iat" value="A" checked={formData.iat==='A'} onChange={handleChange}/><label for="arredondamentos" class="form-control">Arredondamentos</label><br/>
<input type="radio" id="truncamentos"    name="iat" value="T" checked={formData.iat==='T'} onChange={handleChange}/><label for="truncamentos" class="form-control">Truncamentos</label><br/>

</th>
<th>
<label class="form-control">Produção:</label><br/>
<input type="radio" id="propria"      name="ippt" value="P" checked={formData.ippt==='P'} onChange={handleChange}/><label for="propria" class="form-control">Própria</label><br/>
<input type="radio" id="terceirizada" name="ippt" value="T" checked={formData.ippt==='T'} onChange={handleChange} /><label for="terceirizada" class="form-control">Terceirizada</label><br/>

</th>
</tr>
<tr>
<th>
<label for="valorcompra" class="form-control">Preço de Compra:</label>
<input type="text" id="valorcompra" name="valorcompra" value={formData.valorcompra} onChange={handleChange}/><br/>
</th>
<th>
<label for="valorvenda" class="form-control">Preço de Venda:</label>
<input type="text" id="valorvenda" name="valorvenda" value={formData.valorvenda} onChange={handleChange}/><br/>
</th>
<th></th>
<th>
<label for="peso" class="form-control">Peso:</label>
<input type="text" id="peso" name="peso" value={formData.peso} onChange={handleChange}/><br/>
</th>
<th>
<label for="tpoid" class="form-control">Imposto:</label>
<input type="text" id="tpoid" name="tpoid" value={formData.tpoid} onChange={handleChange}/><br/>
</th>
</tr>
<tr>
<th>
<label for="estoqueatual" class="form-control">Estoque Atual:</label>
<input type="text" id="estoqueatual" name="estoqueatual" value={formData.estoqueatual} onChange={handleChange}/><br/>
</th>  
<th>
<label for="estoqueminimo" class="form-control">Estoque Mínimo:</label>
<input type="text" id="estoqueminimo" name="estoqueminimo" value={formData.estoqueminimo} onChange={handleChange}/><br/>
</th>  
<th>
<label for="estoquemaximo" class="form-control">Estoque Máximo:</label>
<input type="text" id="estoquemaximo" name="estoquemaximo" value={formData.estoquemaximo} onChange={handleChange}/><br/>
</th>  
<th>
<label for="caixacom" class="form-control">Caixa com:</label>
<input type="text" id="caixacom" name="caixacom" value={formData.caixacom} onChange={handleChange}/><br/>
</th>  
<th>
<label for="diasvalidade" class="form-control">Validade (Dias):</label>
<input type="text" id="diasvalidade" name="diasvalidade" value={formData.diasvalidade} onChange={handleChange}/><br/>
</th>  

</tr>
</thead>
</table>

<button type="submit" class="botaovermelho">Confirmar</button>
<button type="button" className="botaocinza" onClick={() => {window.location.href = "./ProGrid"; }}>Cancelar</button>&nbsp;



</div>
</form>
</div>


  );
}

export default ProForm;